import CartJS from 'shopify-cartjs';


// NEW CART OBJECT
export default class Cart {
  constructor(json) {
    var _this = this;
    _this.deployed        =   false;

    CartJS.init(json);
    _this.CartJS = CartJS;

    _this.initDOMListners();
    _this.addToCartListner();
    _this.initRivets();

    $(document).on('cart.ready', function(event, cart) {
      console.log("cart ready");
      _this.addToCartListner();
      _this.checkFreeGift(cart)
      _this.checkForOfferedAboveX(cart);
    });
    $(document).on('cart.requestComplete', function(event, cart) {
      console.log("completed");
      // _this.addToCartListner();
      _this.checkFreeGift(cart)
      _this.checkForOfferedAboveX(cart);

    });


  }
  initDOMListners(){
    // console.log('initDOMListners');
    var _this = this;
    $('[action-toggle-minicart]').on('click', function(event) {
      event.preventDefault();
      _this.toggleMiniCart()
    });
  }
  initRivets(){
    // console.log('initRivetjs');
    var _this = this;
    rivets.formatters.equals = function(int, floor){
      int = parseInt(int);
      floor = parseInt(floor);
      if(int == floor ){
        return true;
      }else{
        return false;
      }
    }
    rivets.formatters.money = function(price){
      if (price) {
        // console.log(price);
        var newPrice = parseFloat( parseInt(price) / 100 ).toFixed(2);;
        // console.log(newPrice);
        newPrice = newPrice.toString();
        newPrice = newPrice.replace('.', ',');
        return newPrice + "€";
      }else {
        return ""
      }

    }
    rivets.formatters.stingify = function(integer){

      // console.log("stringify");
      if (integer) {
        var string = integer.toString()
        return string;
      }else {
        return ""
      }

    }
    rivets.formatters.moneyDiff = function(price, base){
      price = parseInt(price) ;
      base = parseInt(base);
      var diff = base - price;
      diff = parseFloat(diff / 100).toFixed(2);
      diff = diff.toString();
      diff = diff.replace('.', ',');
      return diff + "€";
    }
    rivets.formatters.above = function(int, floor){
      int = parseInt(int);
      floor = parseInt(floor);

      if(int > floor ){
        return true;
      }else{
        return false;
      }
    }
    rivets.formatters.under = function(int, floor){
      int = parseInt(int);
      floor = parseInt(floor);
      // console.log(int);
      // console.log(floor);
      // console.log("is under");
      if(int < floor ){
        return true;
      }else{
        return false;
      }
    }
    rivets.formatters.offered = function(properties){
      if( properties["offered"] ){
        return true;
      }else{
        return false;
      }
    }
    rivets.bind(document.querySelector('[data-cart]'),{
        cart: _this
    });
    if ($('[data-mini-cart]').length) {
      rivets.bind(document.querySelectorAll('[data-mini-cart]')[0],{
          cart: _this
      });
    }
    if ($('.minicart__overlay').length) {
      rivets.bind(document.querySelector('.minicart__overlay'),{
          cart: _this
      });

    }



    setTimeout(function() {
      _this.lineItemAdjustListners();
      // console.log('Cart rivets ready');
    }, 200);
  }
  addToCartListner(){
    var _this = this;
    var id, quantity;

    $('[action-add-to-cart]').on('click', function(event) {
      console.log("add to cart");
      event.preventDefault();
      var btn = $(this);
      var btn_text = btn.text();
      btn.addClass('btn--thinking').text('En cours ...');

      if (!$(this).attr('action-add-to-cart')) {
        id = productPage.selected_variant.id;
        quantity = productPage.selected_quantity;
      }else{
        id = parseInt( $(this).attr('action-add-to-cart') );
        quantity = 1;
      }

      var properties = {};
      _this.CartJS.addItem(id, quantity, properties ,{
        "success": function(data, textStatus, jqXHR) {
            // console.log('succes '+textStatus );
            setTimeout(function(){
              console.log('added to cart');
              btn.text('Ajouté !');
              btn.removeClass('btn--thinking');

              _this.toggleMiniCart();
              _this.lineItemAdjustListners();
              // _this.addCompareAtPrice();
            }, 1000);

        },
        "error": function(jqXHR, textStatus, errorThrown) {
            btn.removeClass('btn--thinking');
            console.log('err '+textStatus );
        }
      });
    });



  }
  toggleMiniCart(){
    this.deployed = !this.deployed;
  }
  lineItemAdjustListners(){
    var _this = this;
    $('[data-cart-adjust]').off().on('click', function(event) {
      var line          = parseInt($(this).data('line')) + 1;
      var method        = $(this).data('method');
      switch (method) {
        case 'delete':
          _this.CartJS.removeItem(line,{
            "success": function(data, textStatus, jqXHR) {
                // console.log("ok");

            },
            "error": function(jqXHR, textStatus, errorThrown) {
                // console.log("pas ok delete");
            }
          });
          break;
        case 'add':
          var newQuantity = _this.CartJS.cart.items[(line-1)].quantity + 1;
          _this.CartJS.updateItem(line, newQuantity, {
            "success": function(data, textStatus, jqXHR) {
                // console.log("ok");
            },
            "error": function(jqXHR, textStatus, errorThrown) {
                // console.log("pas ok");
            }
          });
          break;
        case 'remove':
          var newQuantity = _this.CartJS.cart.items[(line-1)].quantity - 1;
          _this.CartJS.updateItem(line, newQuantity, {
            "success": function(data, textStatus, jqXHR) {
                // console.log("ok");
            },
            "error": function(jqXHR, textStatus, errorThrown) {
                // console.log("pas ok");
            }
          });
          break;
        default:
          console.log("dont know what to do");
      }
    })
  }
  checkFreeGift(cart){
    // console.log("checkFreeGift");
    var _this = this;

    var script = $('[offered_product_gift]');


    if (script.length) {
      var id = parseInt(script.data('variant-id'));
      if ( cart.items.length < 1 ) {
        // console.log('je ne fais rien');
      }else{
        // console.log('verif surprise');

        // Si y a pas la surprise dans le panier, alors on l'ajoute
        var exists = false;
        cart.items.map( item =>{
          // console.log(item);
          if (item.variant_id == id) {
            console.log('found surprise in cart');
            exists = id;
          }
        })
        if (!exists) {
          _this.addSuprise(id);
        }else{
          if (cart.item_count == 1) {
            _this.CartJS.clear();
          }
        }
      }
    }

  }
  checkForOfferedAboveX(cart){
    console.log("checkFreeGift");
    var _this = this;
    var script = $('[offered_above_checkbox]');
    if (script.length) {
      var id = parseInt(script.data("variant-id"));
      var limit = parseInt(script.data("limit"));

      var exists = false;
      cart.items.map( item => {
        if (item.variant_id == id) {
          exists = true;
        }
      })

      if (cart.total_price < limit && exists) {
        console.log('je ne fais rien');
        _this.CartJS.removeItemById(id);
      }
      else if (cart.total_price > limit && !exists) {
        _this.addSuprise(id);
      }
    }
  }

  addSuprise(id){
    var _this = this;
    var quantity = 1;
    var properties = {"offered": true};
    _this.CartJS.addItem(id, quantity, properties ,{
      "success": function(data, textStatus, jqXHR) {
          setTimeout(function(){
            console.log('added surprise to cart');
            _this.lineItemAdjustListners();
          }, 800);
          // console.log('succes '+textStatus );
      },
      "error": function(jqXHR, textStatus, errorThrown) {
          console.log('err '+textStatus );
          console.log(errorThrown);
          if (errorThrown == "Unprocessable Entity") {
          }
      }
    });
  }

}
